import { render, staticRenderFns } from "./CourseInfoPhysical.vue?vue&type=template&id=f741e388&"
import script from "./CourseInfoPhysical.vue?vue&type=script&lang=js&"
export * from "./CourseInfoPhysical.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoPhysical.vue?vue&type=style&index=0&id=f741e388&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartBookButton: require('/opt/build/repo/components/Cart/BookButton.vue').default,BlocksColorBlock: require('/opt/build/repo/components/Blocks/ColorBlock.vue').default,CourseInfoVirtual: require('/opt/build/repo/components/CourseInfoVirtual.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
